import React, { useEffect, useState } from 'react';

const Fireworks = ({ colors, interval = 3000 }) => {
  const [explosions, setExplosions] = useState([]);

  useEffect(() => {
    const createExplosion = () => {
      const id = Date.now();
      const x = Math.random() * window.innerWidth;
      const y = Math.random() * (window.innerHeight / 2);
      const color = colors[Math.floor(Math.random() * colors.length)];
      
      const particles = [];
      const particleCount = 30;
      
      for (let i = 0; i < particleCount; i++) {
        const angle = (Math.PI * 2 * i) / particleCount;
        const velocity = 50 + Math.random() * 50;
        particles.push({
          id: `${id}-${i}`,
          x,
          y,
          tx: Math.cos(angle) * velocity,
          ty: Math.sin(angle) * velocity,
          color
        });
      }
      
      setExplosions(prev => [...prev, { id, particles }]);
      
      setTimeout(() => {
        setExplosions(prev => prev.filter(exp => exp.id !== id));
      }, 1000);
    };

    const intervalId = setInterval(createExplosion, interval);
    return () => clearInterval(intervalId);
  }, [colors, interval]);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 9999 }}>
      {explosions.map(explosion => (
        <div key={explosion.id}>
          {explosion.particles.map(particle => (
            <div
              key={particle.id}
              className="firework"
              style={{
                left: particle.x,
                top: particle.y,
                backgroundColor: particle.color,
                '--tx': `${particle.tx}px`,
                '--ty': `${particle.ty}px`
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Fireworks;
